export default __webpack_public_path__ + "static/media/login_background.a8ba9097.png";